import React from "react";
import { Link } from "react-router-dom";
import ResultCard from "../components/ResultCard";
import BoxGrid from "../components/BoxGrid";
import SeoContent from "../components/SeoContent";
import FaqSection from "../components/FaqSection";
import useSeo from "../hooks/useSeo";
import { api, dmyToSlash } from "../services/api";
import { ChevronRight } from "lucide-react";

// India/IST helpers
function istISO() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date()); // yyyy-mm-dd
}
function istLongDate() {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date()); // 30 August 2026
}

export default function Home() {
  const [result, setResult] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  useSeo({
    title: `Sunday Ground Teer Result Today – ${istLongDate()} | F/R & S/R`,
    description:
      "Sunday Ground Teer Result today - live First Round (F/R) and Second Round (S/R) numbers, Common Number, Dream Number, Previous Results & date-wise Chart. Fast, accurate & trusted.",
    canonical: "https://groundsundayteer.com/",
  });

  React.useEffect(() => {
    const iso = istISO();
    const mapResult = (r) => ({
      date: dmyToSlash(r.date),
      city: r.city,
      frTime: r.frTime,
      srTime: r.srTime,
      fr: r.fr,
      sr: r.sr,
    });
    api
      .resultByDate(iso)
      .then(async (r) => {
        if (r && r.fr && r.sr) {
          setResult(mapResult(r));
          return;
        }
        // No result published for today yet — show the latest published previous result
        try {
          const latest = await api.latestResult();
          if (latest && latest.fr && latest.sr) {
            setResult(mapResult(latest));
            return;
          }
        } catch {}
        const [y, m, d] = iso.split("-");
        setResult({
          date: `${d}/${m}/${y}`,
          city: "SUNDAY TEER",
          frTime: "4:30 PM",
          srTime: "5:30 PM",
          notDeclared: true,
        });
      })
      .catch(() => setResult(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pb-4">
      <div className="max-w-5xl mx-auto px-4 py-6">
        <h1 className="text-xl sm:text-2xl font-black text-[#1f2733] text-center mb-1">
          Sunday Ground Teer Result Today
        </h1>
        <p className="text-center text-sm text-gray-500 mb-5">{istLongDate()} • F/R 4:30 PM · S/R 5:30 PM</p>

        {/* Today's Result box */}
        {loading ? (
          <div className="text-center text-gray-400 py-8">Loading today's result...</div>
        ) : result ? (
          <ResultCard result={result} />
        ) : (
          <div className="text-center text-gray-400 py-8">Result unavailable right now.</div>
        )}

        {/* 9 Boxes */}
        <div className="mt-9">
          <BoxGrid />
        </div>

        {/* View all previous results */}
        <div className="mt-8 text-center">
          <Link
            to="/previous-result"
            className="inline-flex items-center gap-1.5 px-6 py-3 rounded-xl bg-[#e8491d] text-white font-bold hover:bg-[#c53a12] transition-colors"
          >
            View All Previous Results <ChevronRight className="w-5 h-5" />
          </Link>
        </div>
      </div>

      <SeoContent variant="home" />
      <FaqSection />
    </div>
  );
}
